import { APIClient } from '@innerhive-internal/innerhive-api-client';
import { ICaremapNote } from '../../notes/model/NotesClient';
import { NotesModel } from '../../notes/model/NotesModel';

// TODO: 'notification-sent:email' really shouldn't be here
const supportedReactions = ['love', 'support', 'gratitude', 'celebrate', 'happy', 'sad', 'notification-sent:email'] as const;

export type IReactionCode = typeof supportedReactions[number];
export class NoteReactionsModelFactory {
    static inject = () => [APIClient];
    constructor(public apiClient: APIClient){}
    create = (notesModel: NotesModel) => {
        return new ReactionsModel(notesModel, this);
    };
}

/**
 * This class name could be misnomer in that usually a model class is stateful.
 *
 * It currently isn't, but it is meant to be the master of the reactions model - hence its name.
 *
 * Reactions are part of notes, so I didn't need it to be stateful (extends State) yet.
 *
 * If / when we do - we'll need to consider how to tie it into the subscription system
 */
export class ReactionsModel {
    constructor(private notesModel: NotesModel, private factory: NoteReactionsModelFactory){

    };

    // TODO: 'notification-sent:email' really shouldn't be here
    getSupportedReactions = (): IReactionCode[] => {
        return supportedReactions.filter(reaction => reaction !== 'notification-sent:email');
    };

    toggleReaction = async ({ note, reaction }: { note: ICaremapNote; reaction: IReactionCode; }) => {
        // TODO: optimistically update, with fallback if fail
        if (this.hasUserReacted({ note, reaction })){
            await this.removeReaction({ note, reaction });
        }
        else {
            await this.addReaction({ note, reaction });
        }
    };

    private addReaction = async ({ note, reaction }: { note: ICaremapNote; reaction: IReactionCode; }) => {
        const { reactions } = await this.factory.apiClient.put(note.links.reaction, { reaction });
        this.notesModel.updateLocalReactions({ note, reactions });
    };

    private removeReaction = async ({ note, reaction }: { note: ICaremapNote; reaction: IReactionCode; }) => {
        if (!note.reactions){
            return;
        }
        if(!note.reactions[reaction]){
            return;
        }

        const { reactions } = await this.factory.apiClient.delete(note.links.reaction, { reaction });
        this.notesModel.updateLocalReactions({ note, reactions });
    };

    hasUserReacted = ({ note, reaction }: { note: ICaremapNote; reaction: IReactionCode; }): boolean => {
        return Boolean(note.reactions?.[reaction]?.people.some(p => p.isMe));
    };

    getNames = ({ note, reaction }: { note: ICaremapNote; reaction: IReactionCode; }): string[]=> {
        return note.reactions?.[reaction]?.people.map(p => p.name) || [];
    };
}
